<template>
  <div class="container">
    <div class="content_top">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>关于我们</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="content_wrapper">
      <div class="header_top">
        <img class="logo" src="@/assets/logo/ise_logo.png" />
        <div class="title">
          <div class="chinese">南京大学智能软件工程实验室</div>
          <div class="english">Nanjing University, Laboratory of Intelligent Software Engineering</div>
        </div>
      </div>
      <div v-html="about"></div>
    </div>

  </div>
</template>

<script>
import requests from "@/api/request";
export default {
  name: "AboutView",
  data() {
    return {
      about: ''
    }
  },
  mounted() {
    this.getAbout();
  },
  methods: {
    async getAbout() {
      return requests({
        url: "/about/showAbout",
        method: "GET"
      }).then(res => {
        this.about = res.data.about;
        // console.log('this.NewsList',this.NewsList);
      }).catch(err => {
        console.log('error', err)
        this.$message({
          showClose: true,
          message: err.message,
          type: 'error'
        });
      });
    },
  }
};
</script>
<style scoped>
.container {
  width: 1200px;
  margin: 0 auto;
}

.content_top {
  margin: 20px 0;
}

.content_wrapper {
  text-align: left;
  border: #a8a4a4 solid 1px;
  padding: 20px;
  margin-bottom: 20px;
  min-height: calc(100vh - 140px);
}

.el-breadcrumb ::v-deep .el-breadcrumb__inner:hover {
  color: #63065f;
}

.header_top {
  padding: 10px 0;
  width: 1200px;
  height: 60px;
  margin: 0 auto;
}

.header_top .logo {
  width: 60px;
  height: 60px;
  float: left;
}

.header_top .title {
  float: left;
  height: 50px;
  padding: 5px 0;
  margin-left: 10px;
  color: #63065f;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: start;
}

.chinese {
  font-size: 23px;
}

.english {
  font-size: 10px;
}
</style>
